<template>
  <div class="mx-3">
    <v-row>
      <v-col
        cols="12"
        lg="3"          
        md="12"
        sm="12"
        xl="2"
      >
        <setup-education-major-dialog-create
          v-if="$hasPermissionTo(['create education majors'])"    
          @created="loadData"
        />
      </v-col>
      <v-spacer />

      <v-col
        class="py-0"
        cols="12"
        lg="3"          
        md="12"
        sm="12"
        xl="2"
      >
        <v-text-field
          v-model="search"
          placeholder="Key in education major here"
          append-icon="search"
          label="Search Education Major"
          hide-no-data
          hide-selected
          clearable 
        />
      </v-col>
    </v-row>

    <v-data-table
      :headers="headers"
      :items="educationMajors"
      :loading="tableLoading"
      :search="search"
    >
      <template v-slot:item.action="{ item }">
        <setup-education-major-dialog-edit
          v-if="$hasPermissionTo(['update education majors'])"    
          :education-major="item"
          @updated="loadData"
        />
        <span class="mx-1" />
        <setup-education-major-dialog-delete
          v-if="$hasPermissionTo(['delete education majors'])"    
          :education-major="item"
          @deleted="loadData"
        />        
      </template>
    </v-data-table>
  </div>
</template>

<script>
  export default {
    components: {
      SetupEducationMajorDialogCreate: () => import('@/components/hris/setup/education/major/DialogCreate'),
      SetupEducationMajorDialogDelete: () => import('@/components/hris/setup/education/major/DialogDelete'),
      SetupEducationMajorDialogEdit: () => import('@/components/hris/setup/education/major/DialogEdit'),
    },
    data () {
      return {
        headers: [
          {
            text: 'Education Major',
            align: 'left',
            value: 'name',
          },
          {
            text: 'Description',
            align: 'left',
            value: 'description',
          },
          {
            text: '',
            sortable: false,
            value: 'action',
          },
        ],
        search: '',
        tableLoading: true,
        educationMajors: [],
      }
    },
    created () {
      this.loadData()
    },
    methods: {
      loadData () {
        this.$api.hrisEducationMajors().list()
          .then(res => {
            this.educationMajors = res.data

            this.tableLoading = false
          })
      },
    },
  }
</script>
